import { render } from "./welcome-page.vue?vue&type=template&id=2667df7f&ts=true"
import script from "./welcome-page.vue?vue&type=script&lang=ts"
export * from "./welcome-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__